import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  discountOffersList,
  discountOffersUpdate,
} from "../../../api/DiscountOffers";
import { batchList } from "../../../api/Batch";

import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { SweetAlertShow, LoadingDiv } from "../../master/Master";
import AcademicPortalLayout from "../AcademicPortalLayout";

export default function DiscountOfferUpdate() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [loading, setLoading] = useState(false);
  const [batches, setBatches] = useState([]);
  const [sessions, setSessions] = useState([]);

  const [data, setData] = useState({});

  const batchFetch = async () => {
    try {
      let addUrl = "";
      if (data?.session_id) {
        addUrl += `session_id=${data?.session_id}`;
      }
      const response = await batchList(addUrl);
      if (response.data.status) {
        setBatches(response?.data?.data);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    }
  };

  useEffect(() => {
    batchFetch();
  }, [data?.session_id]);

  const offerFetch = async () => {
    if (!id) return;
    setLoading(true);
    try {
      const response = await discountOffersList(`&id=${id}`);
      if (response.data.status) {
        const offer = response?.data?.data?.[0] || response?.data?.data;
        setData(offer);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
    batchFetch();
  }, []);

  useEffect(() => {
    offerFetch();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (Number(data?.min_percentage) > Number(data?.max_percentage)) {
      SweetAlertShow(
        "warning",
        "Warning",
        "Min % cannot be greater than Max %.",
      );
      return;
    }

    setLoading(true);
    try {
      const payload = new FormData(e.target);
      const response = await discountOffersUpdate(payload);

      if (response.data.status) {
        SweetAlertShow("success", "Success", response.data.message);
        navigate("/discount/offers/list");
      } else {
        SweetAlertShow("warning", "Warning", response.data.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <AcademicPortalLayout />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="text-primary m-0">
                          Update Discount Offer
                        </h4>

                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <input type="hidden" name="id" id="id" value={data?.id} />
                            <div className="col-md-6 mb-4">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="session_id"
                                  value={data?.session_id}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      session_id: e.target.value,
                                      batch_id: "",
                                    })
                                  }
                                  required
                                >
                                  <option value="">Select Session</option>
                                  {sessions?.map((session, index) => (
                                    <option key={index} value={session.id}>
                                      {session.session} :{" "}
                                      {session?.status === "1"
                                        ? "Active"
                                        : "Inactive"}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Session</label>
                              </div>
                            </div>

                            <div className="col-md-6 mb-4">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  value={data?.batch_id}
                                  name="batch_id"
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      batch_id: e.target.value,
                                    })
                                  }
                                  required
                                >
                                  <option value="">Select Batch</option>
                                  {batches?.map((batch) => (
                                    <option key={batch.id} value={batch.id}>
                                      {batch.title}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Batch</label>
                              </div>
                            </div>

                            <div className="col-12 mb-4">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  name="title"
                                  className="form-control input-capitalize"
                                  placeholder="Offer Title"
                                  value={data?.title}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      title: e.target.value,
                                    })
                                  }
                                  required
                                />
                                <label>Offer Title</label>
                              </div>
                            </div>

                            <div className="col-12">
                              <h6 className="text-muted mb-3">
                                Eligibility — Previous Year's Marks Range
                              </h6>
                            </div>

                            <div className="col-md-6 mb-4">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="number"
                                  className="form-control"
                                  min="0"
                                  max="100"
                                  name="min_percentage"
                                  placeholder="Min %"
                                  value={data?.min_percentage}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      min_percentage: e.target.value,
                                    })
                                  }
                                  required
                                />
                                <label>Min Previous Year % Required</label>
                              </div>
                            </div>

                            <div className="col-md-6 mb-4">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="number"
                                  className="form-control"
                                  min="0"
                                  max="100"
                                  placeholder="Max %"
                                  name="max_percentage"
                                  value={data?.max_percentage}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      max_percentage: e.target.value,
                                    })
                                  }
                                  required
                                />
                                <label>Max Previous Year % Required</label>
                              </div>
                            </div>

                            <div className="col-12">
                              <h6 className="text-muted mb-3">Discount</h6>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="btn-group" role="group">
                                <button
                                  type="button"
                                  className={`btn ${
                                    data?.discount_type === "percentage"
                                      ? "btn-primary"
                                      : "btn-outline-primary"
                                  }`}
                                  onClick={() =>
                                    setData({
                                      ...data,
                                      discount_type: "percentage",
                                    })
                                  }
                                >
                                  <i className="ri-percent-line me-1"></i>
                                  Percentage
                                </button>
                                <button
                                  type="button"
                                  className={`btn ${
                                    data?.discount_type === "fixed"
                                      ? "btn-primary"
                                      : "btn-outline-primary"
                                  }`}
                                  onClick={() =>
                                    setData({
                                      ...data,
                                      discount_type: "fixed",
                                    })
                                  }
                                >
                                  <i className="ri-money-rupee-circle-line me-1"></i>
                                  Fixed Amount
                                </button>
                              </div>
                            </div>

                            <div className="col-md-6 mb-4">
                              <input
                                type="hidden"
                                name="discount_type"
                                value={data?.discount_type}
                              />
                              {data?.discount_type === "percentage" ? (
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Discount"
                                    name="discount_percentage"
                                    value={data?.discount_percentage}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        discount_percentage: e.target.value,
                                      })
                                    }
                                    required
                                  />
                                  <label>Discount Percentage (%)</label>
                                </div>
                              ) : (
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Amount"
                                    name="discount_amount"
                                    value={data?.discount_amount}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        discount_amount: e.target.value,
                                      })
                                    }
                                    required
                                  />
                                  <label>Discount Amount (₹)</label>
                                </div>
                              )}
                            </div>

                            <div className="col-md-6 mb-4">
                              <div className="form-floating form-floating-outline">
                                <textarea
                                  className="form-control"
                                  name="remark"
                                  placeholder="Remark"
                                  value={data?.remark}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      remark: e.target.value,
                                    })
                                  }
                                ></textarea>
                                <label>Remark</label>
                              </div>
                            </div>
                          </div>

                          <div className="d-flex gap-2">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              disabled={loading}
                            >
                              {loading ? "Updating..." : "Update Offer"}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
